var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function LockLockedIconInner(props) {
    return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 15.5C10 14.3954 10.8954 13.5 12 13.5C13.1046 13.5 14 14.3954 14 15.5C14 16.2403 13.5978 16.8866 13 17.2324V18.0009C13 18.5527 12.5561 19 12 19C11.4477 19 11 18.5566 11 18.0009V17.2324C10.4022 16.8866 10 16.2403 10 15.5ZM6 8.00016C6 4.68618 8.68587 2 12 2C15.3131 2 18 4.68778 18 8.00026V10.5C19.1048 10.5011 20 11.3935 20 12.5031V19.9969C20 21.1032 19.1055 22 17.9979 22H6.00213C4.89638 22 4 21.1072 4 19.9969V12.5031C4 11.3975 4.89337 10.5011 6 10.5V8.00016ZM8 10.5H16V8.00026C16 5.7922 14.2084 4 12 4C9.79049 4 8 5.7907 8 8.00016V10.5ZM6 12.5V20H18V12.5H6Z", fill: "" })));
}
export var LockLockedIcon = function (props) { return (React.createElement(SvgIcon, __assign({ inheritViewBox: true, component: LockLockedIconInner }, props))); };
//# sourceMappingURL=LockLockedIcon.js.map